module.exports = __webpack_public_path__ + "static/img/smartImg.f03b824.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/smartImg.webp
// module id = lhtp
// module chunks = 1